<template>
  <el-menu
    :default-active="activeMenu"
    :collapse="sidebar.opened"
    :collapse-transition="false"
  >
    <ul class="menu-wrapper" :class="{collapse: sidebar.opened}" v-for="menu in menuData" :key="menu.path">
      <MenuItem :menu="menu" :isCollapse.sync="sidebar.opened" />
    </ul>
  </el-menu>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import store from '@/store'
import {routes} from '@/router'
import MenuItem from './menuItem'

export default {
  name: 'SideMenus',
  components: {
    MenuItem
  },
  data() {
    return {
      isCollapse: false
    }
  },
  computed: {
    ...mapGetters(['sidebar']),
    ...mapState({
      menuData: state => state.permission.routes
    }),
    activeMenu() {
      const route = this.$route
      const {meta, path} = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    }
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
</style>
